/**
 * Inspection / property-appointment `event.start.dateTime` and `event.end.dateTime` are stored as
 * Brisbane wall-clock time. Records written since ~Feb 2026 come back with a trailing `Z` that is
 * NOT real UTC — Mongoose casts the zone-less string the save path sends into a `Date` — so the
 * `date` pipe, `new Date()` and `moment()` all shift them by the viewer's offset and render the
 * wrong day for anything from 2pm onward. Stripping the zone makes the digits read as local time.
 *
 * `'2026-10-01T17:30:46.000Z'` -> `'2026-10-01T17:30:46'`
 * `'2026-02-21T13:00:39'`      -> unchanged (older records were already stored zone-less)
 *
 * Never apply this to Google Calendar events (`time_hour.events.items[*].start.dateTime`) — those
 * are real UTC instants and are correct as-is. See `docs/backend/leads/INSPECTION_DATE_DISPLAY_FRONTEND.md`.
 */
export function toWallClock(value: string | Date | null | undefined): string | null {
  if (!value) {
    return null;
  }
  const raw = value instanceof Date ? value.toISOString() : String(value);
  return raw.trim().replace(/(\.\d+)?(Z|[+-]\d{2}:?\d{2})$/i, '');
}
